/**
 * PDP Thumbnail Sliding Carousel
 * Shows 4 thumbnails at a time, slides one at a time smoothly.
 */
(function () {
  var VISIBLE = 4;
  var MAX_ATTEMPTS = 20;
  var attempts = 0;

  function setup() {
    var scrollHint = document.querySelector(
      '.product-information__grid .slideshow-controls__thumbnails-container'
    );
    if (!scrollHint) {
      if (++attempts < MAX_ATTEMPTS) setTimeout(setup, 300);
      return;
    }

    var track = scrollHint.querySelector('.slideshow-controls__thumbnails');
    if (!track) return;

    var thumbs = track.querySelectorAll('.slideshow-control');
    if (!thumbs.length || thumbs.length <= VISIBLE) return;

    // Prevent double-init
    if (scrollHint.getAttribute('data-pdp-slide-init')) return;
    scrollHint.setAttribute('data-pdp-slide-init', '1');

    // Wrap the track in a clipping viewport
    var viewport = document.createElement('div');
    viewport.className = 'pdp-thumb-viewport';
    track.parentNode.insertBefore(viewport, track);
    viewport.appendChild(track);

    var maxIndex = thumbs.length - VISIBLE; // last valid offset index
    var currentIndex = 0;

    // Read the actual CSS gap from the track
    function getGap() {
      return parseFloat(getComputedStyle(track).gap) || 0;
    }

    // Measure one thumb width (recalc on resize)
    function thumbWidth() {
      return thumbs[0].offsetWidth;
    }

    function slide() {
      var gap = getGap();
      var offset = currentIndex * (thumbWidth() + gap);
      track.style.transform = 'translateX(' + (-offset) + 'px)';
      prevBtn.disabled = currentIndex <= 0;
      nextBtn.disabled = currentIndex >= maxIndex;
    }

    // Set CSS variable so thumbnails size to 1/4 of viewport
    function measure() {
      viewport.style.setProperty('--pdp-thumb-viewport-w', viewport.clientWidth + 'px');
    }

    // Build arrows
    var controlsEl = scrollHint.closest('slideshow-controls') || scrollHint.parentNode;
    var nav = document.createElement('div');
    nav.className = 'pdp-thumb-nav';

    var prevBtn = document.createElement('button');
    prevBtn.type = 'button';
    prevBtn.setAttribute('aria-label', 'Previous thumbnail');
    prevBtn.className = 'pdp-thumb-nav__btn pdp-thumb-nav__btn--prev';
    prevBtn.innerHTML =
      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="15 18 9 12 15 6"></polyline></svg>';

    var nextBtn = document.createElement('button');
    nextBtn.type = 'button';
    nextBtn.setAttribute('aria-label', 'Next thumbnail');
    nextBtn.className = 'pdp-thumb-nav__btn pdp-thumb-nav__btn--next';
    nextBtn.innerHTML =
      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 6 15 12 9 18"></polyline></svg>';

    nav.appendChild(prevBtn);
    nav.appendChild(nextBtn);

    viewport.appendChild(nav);

    prevBtn.addEventListener('click', function () {
      if (currentIndex > 0) { currentIndex--; slide(); }
    });

    nextBtn.addEventListener('click', function () {
      if (currentIndex < maxIndex) { currentIndex++; slide(); }
    });

    // When the active slide changes, ensure its thumbnail is visible
    function ensureVisible() {
      var sel = track.querySelector('.slideshow-control[aria-selected="true"]');
      if (!sel) return;
      var idx = -1;
      for (var i = 0; i < thumbs.length; i++) {
        if (thumbs[i] === sel) { idx = i; break; }
      }
      if (idx === -1) return;
      // If selected thumb is before the visible window, shift left
      if (idx < currentIndex) {
        currentIndex = idx;
        slide();
      }
      // If selected thumb is after the visible window, shift right
      if (idx >= currentIndex + VISIBLE) {
        currentIndex = idx - VISIBLE + 1;
        slide();
      }
    }

    var observer = new MutationObserver(ensureVisible);
    for (var i = 0; i < thumbs.length; i++) {
      observer.observe(thumbs[i], { attributes: true, attributeFilter: ['aria-selected'] });
    }

    // Initial sizing + render
    measure();
    slide();

    // Recalc on resize
    var resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () { measure(); slide(); }, 100);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setup);
  } else {
    setup();
  }
})();
